import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_k8wkg3fhs3: FaireBrandEntity = {
  token: "b_k8wkg3fhs3",
  type: "brand",
  name: "Gifts From The Crypt",
  avatarUrl:
    "https://cdn.faire.com/fastly/5383eb55458c0d10e3fb265a2cec7586e2a5298e48420b5bff6ae7e8aa8626cb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/92ea3dc943b9f7a916f0640c46640de219196ba465fd5a71240133f068add823.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5383eb55458c0d10e3fb265a2cec7586e2a5298e48420b5bff6ae7e8aa8626cb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/92ea3dc943b9f7a916f0640c46640de219196ba465fd5a71240133f068add823.jpeg",
  location: "London, GBR",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 16,
  isTopShop: true,
  isInsider: false,
  description:
    "Founded in 2019 and based in the UK, we are a jewellery and accessories brand dedicated to offering high-quality, stylish pieces at unbeatable prices. Our designs have been featured on ITV’s Love Island and are worn by customers across Europe, including collaborations with some of the continent’s largest vintage clothing companies.\n\nSustainability is at the heart of what we do—we use recycled materials for our jewellery and packaging wherever possible, ensuring that our pieces are both beautiful and eco-friendly. Whether you're looking for timeless classics or bold statement pieces, our collection is designed to elevate any look while remaining affordable.\n\nWith a passion for craftsmanship and a commitment to quality, we create jewellery that customers love. Explore our collection and discover pieces that can take your store to the next level!\n\nAnd if you're based in the US, don't worry about the new tariff laws - we cover those from our side!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:08.242Z",
    importedBy: "entity-db-cli",
  },
};
